import { ConversionType, ErrorResponse, PackingBOMStatusEnum, PackingRequiredResponse, Series, StatusEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import { CommonResponse, CommonResponseArr, GetItemForProductRequest, ItemCategoriesDropDownResponseModel, ItemCategoryDropDownDto, ItemCategoryReq, ItemRequest, ItemSubCategoryRequest, SizeRequest, SizesDropDownDto } from '@gtpl/shared-models/masters';
import { ItemsRequest, StoreConsumptionItemQtyReq, StoreConsumptionItemsRequest } from './dto/sale-order-id.request';

import { BomDetailsCreationResponseModel, BomDetailsForIdResponseModel, BOMDetailViewResponse, BomInfo, BomInfoForDetailView, BomItemActiveResponse, BomPackingItemsDto as BomPackingItemsForSO, BomSODto, BomUpdateRequest, GetAllBomDataResponseModel, GetAllBomDetailsResponseModel, ItemsDetailsResponseModel, ItemsDropDownDto, SOInfoReq, SoPackingStatusModel } from '@gtpl/shared-models/sale-management';
import { ItemCategoryService, ItemsService, ItemSubCategoryService, SizesService } from '@gtpl/shared-services/masters';
import { Injectable } from '@nestjs/common';
import { getManager, In, MoreThan, Raw } from 'typeorm';
import { catchError } from 'rxjs/operators';
import { PackingMaterialAdapter } from './adapters/packing-material.adapter';
import { CreateBomDTO } from './dto/create-bom.dto';
import { BomPackingItemsDto } from './dto/packing-materials.dto';
import { BomRepository } from './repository/bom-calculation.repository';
import { SoRepository } from './repository/so-repository';
import { SaleOrderIdRequest } from './dto/sale-order-id.request';
import { BomIdRequest } from './dto/bom-id-request';
import { CustomersInfo, LocationUpdateRequest, OrderInfo, PoNumbersResponseModel, ProductConversionReq, RequiredPackingResponse, SoPackingStatusDto, StocktemRequest, UnitsRequiredBomInfo } from '@gtpl/shared-models/procurement-management';
import { StockService } from '@gtpl/shared-services/procurement';
import { UpdateBomItemDto } from './dto/update-bom-item.dto';
import { BomItemRemovedQty } from './dto/remove-bom-assigned-qty.dto';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { ReProcessRequiredQty } from './dto/re-processing-required-qty.request';
import { FGStockData } from '@gtpl/shared-models/warehouse-management';
import { ChartInfo } from '@gtpl/shared-models/production-management';
import { SaleOrderIdsRequest } from './dto/sale-order-ids.request';
import { PoBomInfo } from './dto/po-bom-info';
import { SaleorderService } from './saleorder.service';
import appSettings from 'apps/services/config';
import { BomIdsRequest } from './dto/bom-ids.request';
import { PackingBomFilter } from './dto/packing-bom-filter.dto';
import { SoPackingStatusRequest } from './so-packing-status.request';
import { PackingBomLogRepository } from './repository/packing-bom-log-repository';
// import { LogsService } from '@gtpl/shared-services/user-logs';
// import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class BomCalculationService {
    constructor(
        //   private logService:LogsService,

        private bomRepo: BomRepository,
        private adapter: PackingMaterialAdapter,
        private soRepo: SoRepository,
        private packingBomLogRepo: PackingBomLogRepository,
        private CategoryService: ItemCategoryService,
        private itemService: ItemsService,
        private sizeService: SizesService,
        private stockService: StockService,
        private subCategoryService: ItemSubCategoryService,
        private saleService: SaleorderService
    ) { }


    /**
     * 
     * @param bomData 
     */
    async saveBomPackingMaterialDetails(bomData: CreateBomDTO): Promise<BomDetailsCreationResponseModel> {
        try {
            let saveBom;
            for (const bom of bomData.bomItems) {
                const bomEntity = await this.adapter.convertDtoToEntity(bom);
                saveBom = await this.bomRepo.save(bomEntity);
            }
            if (bomData.deletedBomItems.length > 0) {
                const deleteResponse = await this.bomRepo.update({ packingMaterialId: In(bomData.deletedBomItems) }, { isActive: false });
            }
            if (saveBom) {
                return new BomDetailsCreationResponseModel(true, 1111, 'Created Successfully');
            } else {
                throw new ErrorResponse(9999, 'Failed To Create');
            }
        } catch (error) {
            return error;
        }
    }


    async savePoBomItems(req: PoBomInfo): Promise<BomDetailsCreationResponseModel> {
        const manager = new GenericTransactionManager();
        try {
            const bomInformation: BomInfo[] = [];
            let saveBom;
            await manager.startTransaction();
            for (const bom of req.bomItems) {
                const bomEntity = await this.adapter.convertPoBomDtoToEntity(bom);
                saveBom = await manager.getCustomRepository(BomRepository).save(bomEntity);
                bomInformation.push(new BomInfo(saveBom.packingMaterialId, saveBom.saleOrderId, saveBom.itemId));
                if (!saveBom) {
                    throw new ErrorResponse(9999, 'Failed To Create');
                }
            }

            if (saveBom) {
                manager.completeTransaction();
                return new BomDetailsCreationResponseModel(true, 1111, 'Created Successfully', bomInformation);
            } else {
                throw new ErrorResponse(9999, 'Failed To Create');
            }
        } catch (error) {
            await manager.releaseTransaction();
            return error;
        }
    }

    /**
     * 
     * @returns 
     */
    async getAllBomData(soId): Promise<GetAllBomDataResponseModel> {
        try {
            const bomDetails = this.bomRepo.createQueryBuilder("BomDetails")
                // .select(["BomDetails.item_category_id as itemCategoryId","BomDetails.item_id as itemId","BomDetails.size as size","SUM(BomDetails.quantity) as quantity","BomDetails.status as status","BomDetails.sale_order_id as saleOrderId"])
                // .groupBy('BomDetails.sale_order_id')
                // .addGroupBy('BomDetails.status')
                // .addGroupBy('BomDetails.itemCategoryId')
                // .addGroupBy("BomDetails.itemId")
                // .addGroupBy("BomDetails.size")
                .where(`packing_category is not null`)
                .andWhere(`sale_order_id = ` + soId)
            const bomInfo = await bomDetails.getMany();
            console.log(bomInfo);
            if (bomInfo) {
                const bomSoData: BomPackingItemsDto[] = [];
                // for(const packingMaterial of bomInfo){
                // const bomDataForSaleOrder : BomPackingItemsForSO[]=[];
                // if(packingMaterial){
                for (const bomData of bomInfo) {
                    // get item category details for item category id
                    const itemCategoryReq = new ItemCategoryReq(bomData.itemCategoryId);
                    const itemCategoryDetails = this.CategoryService.getItemCategoryById(itemCategoryReq);
                    if (!itemCategoryDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item Category');
                    }


                    // get item sub category details for item subs category id
                    const itemSubCategoryReq = new ItemSubCategoryRequest(bomData.itemSubCategoryId);
                    const itemSubCategoryDetails = this.subCategoryService.getItemSubCategoryForId(itemSubCategoryReq);
                    if (!itemSubCategoryDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item Category');
                    }



                    // get item details for item id 
                    const itemReq = new ItemRequest(bomData.itemId);
                    const itemDetails = this.itemService.getItemById(itemReq);
                    if (!itemDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item');
                    }



                    // if(bomData.size==0||bomData.size==1){
                    //     console.log("Size Information");
                    //     console.log("Size Information");
                    //     console.log(bomData);
                    //     console.log("Size Information");
                    //     console.log(bomData.size); 
                    //     console.log("Size Information");
                    //     console.log("Size Information");
                    //     console.log("Size Information"); 
                    // }
                    // const size = new SizeRequest(bomData.size);
                    // const sizeDetails =await this.sizeService.getSizeDataById(size);
                    // if (!size) {
                    //     throw new ErrorResponse(1111, 'Failed to Get Size');
                    // }

                    await Promise.all([itemCategoryDetails, itemDetails, itemSubCategoryDetails]).then(res => {
                        const sizeDetails = new SizesDropDownDto(res[1].sizeId, res[1].sizeName);
                        const bomSo = new BomPackingItemsDto(res[0], res[1], (res[2]) ? res[2] : null, (sizeDetails) ? sizeDetails : null, Number(bomData.quantity), bomData.packingCategory, bomData.isActive, bomData.status, bomData.saleOrderId, bomData.createdUser, bomData.updatedUser, bomData.packingMaterialId, Number(bomData.requiredQuantity), Number(bomData.receivedQuantity), Number(bomData.avilableQuantity));
                        bomSoData.push(bomSo);
                    })
                }

                // }
                return new GetAllBomDataResponseModel(true, 1111, 'Bom Details Found', bomSoData);
            } else {
                throw new ErrorResponse(9999, 'No data Found')
            }
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async getAllBomDetails(): Promise<GetAllBomDetailsResponseModel> {
        const bomDetails = await this.soRepo.find({ 'relations': ['BomDetailsInfo'] });

        if (bomDetails) {
            const bomSoData: BomSODto[] = [];
            for (const packingMaterial of bomDetails) {
                const bomDataForSaleOrder: BomPackingItemsForSO[] = [];
                if (packingMaterial.BomDetailsInfo.length) {
                    for (const bomData of packingMaterial.BomDetailsInfo) {
                        // get item category details for item category id
                        const itemCategoryReq = new ItemCategoryReq(bomData.itemCategoryId);
                        const itemCategoryDetails = this.CategoryService.getItemCategoryById(itemCategoryReq);
                        if (!itemCategoryDetails) {
                            throw new ErrorResponse(1111, 'Failed to Get Item Category');
                        }

                        // get item details for item id 
                        const itemReq = new ItemRequest(bomData.itemId);
                        const itemDetails = this.itemService.getItemById(itemReq);
                        if (!itemDetails) {
                            throw new ErrorResponse(1111, 'Failed to Get Item');
                        }

                        const size = new SizeRequest(bomData.size);
                        const sizeDetails = this.sizeService.getSizeDataById(size);
                        if (!size) {
                            throw new ErrorResponse(1111, 'Failed to Get Size');
                        }

                        // get item sub category details for item sub category id
                        const itemSubCategoryReq = new ItemSubCategoryRequest(bomData.itemSubCategoryId);
                        const itemSubCategoryDetails = this.subCategoryService.getItemSubCategoryForId(itemSubCategoryReq);
                        if (!itemSubCategoryDetails) {
                            throw new ErrorResponse(1111, 'Failed to Get Item Category');
                        }

                        await Promise.all([itemCategoryDetails, itemDetails, sizeDetails, itemSubCategoryDetails]).then(res => {
                            const bom = new BomPackingItemsForSO((res[0]) ? res[0] : null, (res[1]) ? res[1] : null, (res[3]) ? res[3] : null, (res[2]) ? res[2] : null, bomData.quantity, bomData.status, bomData.packingMaterialId, bomData.createdUser, bomData.saleOrderId, bomData.updatedUser, bomData.packingCategory, bomData.isActive, bomData.receivedQuantity, bomData.requiredQuantity, bomData.avilableQuantity);
                            bomDataForSaleOrder.push(bom);
                        })
                    }
                    const bomSo = new BomSODto(packingMaterial.saleOrderId, packingMaterial.saleOrderNumber, bomDataForSaleOrder);
                    bomSoData.push(bomSo);
                }
            }
            return new GetAllBomDetailsResponseModel(true, 1111, 'Bom Details Found', bomSoData);
        } else {
            throw new ErrorResponse(9999, 'No data Found')
        }
    }

    async getItemsDetails(itemsRequest: ItemsRequest): Promise<ItemsDetailsResponseModel> {
        console.log(itemsRequest, 'itemsRequest')
        try {
            let bomDetails = this.bomRepo.createQueryBuilder("BomDetails")
                .where("BomDetails.sale_order_id =" + itemsRequest.saleOrderId)
                .andWhere("BomDetails.item_category_id = " + 6)
            if (itemsRequest.isPreparedMaterial) {
                bomDetails = bomDetails.andWhere('')
            }
            const ItemCategoryDropDown = await bomDetails.getMany();
            console.log(ItemCategoryDropDown);
            const data: ItemsDropDownDto[] = [];
            if (ItemCategoryDropDown) {
                console.log(ItemCategoryDropDown);
                for (const item of ItemCategoryDropDown) {
                    const itemName = await this.itemService.getItemById({ itemId: item.itemId });
                    console.log(itemName.itemId);
                    if (itemName.itemId != undefined) {
                        const itemDropdown = new ItemsDropDownDto(item.itemId, itemName.itemName);
                        data.push(itemDropdown);
                    }
                }

                return new ItemsDetailsResponseModel(true, 1111, 'Items retrived Successfully.', data);
            } else {
                throw new ErrorResponse(9999, 'No data Found')
            }
        } catch (error) {
            return error;
        }

    }

    /**
    * 
    * @returns 
    */
    async getAllBomDetailsForSoId(saleOrderIdRequest: SaleOrderIdRequest): Promise<BomDetailsForIdResponseModel> {
        const saleOrderId = saleOrderIdRequest.saleOrderId;
        const bomDetails = await this.bomRepo.BomDetailsForSo(saleOrderIdRequest);
        const bomDataForSaleOrder: BomPackingItemsForSO[] = [];
        if (bomDetails.length > 0) {
            for (const bomData of bomDetails) {

                // get item category details for item category id
                const itemCategoryReq = new ItemCategoryReq(bomData.itemCategoryId);
                const itemCategoryDetails = this.CategoryService.getItemCategoryById(itemCategoryReq);

                // get item details for item id 
                const itemReq = new ItemRequest(bomData.itemId);
                const itemDetails = this.itemService.getItemById(itemReq);

                const size = new SizeRequest(bomData.size);
                const sizeDetails = this.sizeService.getSizeDataById(size);

                const stockData = await this.stockService.getAvailableStockQty(
                    new StocktemRequest(undefined, bomData.itemCategoryId, bomData.itemId, saleOrderIdRequest.plantId)
                );

                // get item sub category details for item sub category id
                const itemSubCategoryReq = new ItemSubCategoryRequest(bomData.itemSubCategoryId);
                const itemSubCategoryDetails = this.subCategoryService.getItemSubCategoryForId(itemSubCategoryReq);
                if (!itemSubCategoryDetails) {
                    throw new ErrorResponse(1111, 'Failed to Get Item Category');
                }

                let Qty = 0;
                if (stockData.status) {
                    Qty = stockData.data.physicalQuantity;
                }
                await Promise.all([itemCategoryDetails, itemDetails, sizeDetails, itemSubCategoryDetails]).then(res => {
                    const bom = new BomPackingItemsForSO((res[0]) ? res[0] : null, (res[1]) ? res[1] : null, (res[3]) ? res[3] : null, (res[2]) ? res[2] : null, bomData.quantity, bomData.status, bomData.packingMaterialId, bomData.createdUser, bomData.saleOrderId, bomData.updatedUser, bomData.packingCategory, bomData.isActive, Qty, bomData.requiredQuantity, bomData.receivedQuantity, bomData.AssignedQuantity, bomData.poQty, '', bomData.isRequired, bomData.isActiveRevised, bomData.isQtyRevised);
                    bomDataForSaleOrder.push(bom);
                })
            }
            return new BomDetailsForIdResponseModel(true, 1111, 'Bom Details Found For Sale Order', bomDataForSaleOrder);

        } else {
            return new BomDetailsForIdResponseModel(false, 9999, 'No Bom Details Found For Sale Order', bomDataForSaleOrder);
        }
    }

    async getAllBomDetailsForSoIdInPo(saleOrderIdRequest: SaleOrderIdsRequest): Promise<BomDetailsForIdResponseModel> {
        const manager = getManager();
        const saleOrderId = saleOrderIdRequest.saleOrderId;
        const bomDetails = await this.bomRepo.BomDetailsForSoInPO(saleOrderIdRequest);

        const bomDataForSaleOrder: BomPackingItemsForSO[] = [];
        if (bomDetails.length > 0) {
            for (const bomData of bomDetails) {

                // get item category details for item category id
                const itemCategoryReq = new ItemCategoryReq(bomData.itemCategoryId);
                const itemCategoryDetails = this.CategoryService.getItemCategoryById(itemCategoryReq);

                // get item details for item id 
                const itemReq = new ItemRequest(bomData.itemId);
                const itemDetails = this.itemService.getItemById(itemReq);

                const size = new SizeRequest(bomData.size);
                const sizeDetails = this.sizeService.getSizeDataById(size);
                // get item sub category details for item sub category id
                const itemSubCategoryReq = new ItemSubCategoryRequest(bomData.itemSubCategoryId);
                const itemSubCategoryDetails = this.subCategoryService.getItemSubCategoryForId(itemSubCategoryReq);
                if (!itemSubCategoryDetails) {
                    throw new ErrorResponse(1111, 'Failed to Get Item Category');
                }


                let poQty = Number(bomData.quantity) - (Number(bomData.AssignedQuantity) + Number(bomData.poQty))
                // get item available qty from stock
                const stockQuery = `SELECT physical_quantity as physicalQuantity from ` + appSettings.procure_db + `.stock s where item_id=${bomData.itemId} and saleOrder_id=0 and unit_id=${bomData.saleOrderInfo.SoInvDetailsInfo.processingUnit}`;
                const availableStock = await manager.query(stockQuery);
                let availableStockQty;
                let itemQty;
                if (availableStock?.length) {
                    availableStockQty = availableStock.find((val) => val.physicalQuantity);
                }

                // get item minimum qty from stock
                const itemQuery = `SELECT min_qnty as minimumQty from ` + appSettings.masters_db + `.items i where item_id=${bomData.itemId}`;
                const itemMinQty = await manager.query(itemQuery);
                if (itemMinQty?.length) {
                    itemQty = itemMinQty.find((val) => val.minimumQty);
                }

                const minimumQty = itemQty?.minimumQty || 0;
                const availableQty = availableStockQty?.physicalQuantity || 0;

                if (Number(minimumQty) > Number(availableQty)) {
                    poQty = Number(poQty) + (Number(minimumQty) - Number(availableQty));
                }
                //  else if (Number(minimumQty) < Number(availableQty)) {
                //     poQty = Number(poQty) - (Number(availableQty) - Number(minimumQty));
                // }

                if (poQty > 0) {
                    await Promise.all([itemCategoryDetails, itemDetails, sizeDetails, itemSubCategoryDetails]).then(res => {
                        const bom = new BomPackingItemsForSO((res[0]) ? res[0] : null, (res[1]) ? res[1] : null, (res[3]) ? res[3] : null, (res[2]) ? res[2] : null, poQty, bomData.status, bomData.packingMaterialId, bomData.createdUser, bomData.saleOrderId, bomData.updatedUser, bomData.packingCategory, bomData.isActive, availableQty, bomData.requiredQuantity, bomData.receivedQuantity, bomData.AssignedQuantity, bomData.poQty, bomData.saleOrderInfo.saleOrderNumber + " - " + bomData.saleOrderInfo.SoInvDetailsInfo.poNumber);
                        bomDataForSaleOrder.push(bom);
                    })
                }

            }
            if (bomDataForSaleOrder.length) {
                return new BomDetailsForIdResponseModel(true, 1111, 'Bom Details Found For Sale Order', bomDataForSaleOrder);
            } else {
                return new BomDetailsForIdResponseModel(false, 9999, 'Po Already Created For bom Items For Selected SO', bomDataForSaleOrder);
            }

        } else {
            return new BomDetailsForIdResponseModel(false, 9999, 'No Bom Details Found For Sale Order', bomDataForSaleOrder);
        }
    }



    async BomDetailsForSoInPackingBom(bomReq: BomIdsRequest): Promise<BomDetailsForIdResponseModel> {
        let poQty;
        const manager = getManager();
        // get the item ids for the requesting PO
        const refBomDetails = await this.bomRepo.find({ select: ['itemId'], where: { packingMaterialId: In(bomReq.packingMaterialId) } });
        if (refBomDetails.length == 0) {
            throw new ErrorResponse(0, 'Bom details not found for the requesting po');
        }
        let atLeastOneItemAllocatedFromStock = false;
        const unit = bomReq.unitId; // PENDING
        const itemCodeCurrStockAtSameUnit = new Map<number, number>(); // a map of item_code, its stock in current location
        const minMaintainableStockQty = new Map<number, number>(); // a map of item_code, its min threshold stock to be maintained
        const bomDataForSaleOrder: BomPackingItemsForSO[] = [];
        const itemIds: number[] = refBomDetails.map(rec => Number(rec.itemId));
        // for this item ID, get all the sale orders that requested this material for the current location 
        const pendingRequestsForItem = await this.bomRepo.BomDetailsForItemCodeAndUnit(itemIds, unit);
        for (const bomData of pendingRequestsForItem) {
            // get item category details for item category id
            const itemCategoryReq = new ItemCategoryReq(bomData.itemCategoryId);
            const itemCategoryDetails = this.CategoryService.getItemCategoryById(itemCategoryReq);
            const currPackingMaterialId = bomData.packingMaterialId;
            // get item details for item id 
            const itemReq = new ItemRequest(bomData.itemId);
            const itemDetails = this.itemService.getItemById(itemReq);

            const size = new SizeRequest(bomData.size);
            const sizeDetails = this.sizeService.getSizeDataById(size);
            // get item sub category details for item sub category id
            const itemSubCategoryReq = new ItemSubCategoryRequest(bomData.itemSubCategoryId);
            const itemSubCategoryDetails = this.subCategoryService.getItemSubCategoryForId(itemSubCategoryReq);
            if (!itemSubCategoryDetails) {
                throw new ErrorResponse(1111, 'Failed to Get Item Category');
            }
            poQty = Number(bomData.quantity) - (Number(bomData.AssignedQuantity) + Number(bomData.poQty));
            // get item available qty from stock
            const itemCode = bomData.itemId;
            if (!itemCodeCurrStockAtSameUnit.has(itemCode)) {
                // get item minimum qty from stock
                let itemQty = 0;
                const itemQuery = `SELECT min_qnty as minimumQty from ` + appSettings.masters_db + `.items i where item_id=${bomData.itemId}`;
                // please ensure the db selects and the prototyped objects are in same casing {minimumQty: number}
                const itemMinQtyResult: { minimumQty: number }[] = await manager.query(itemQuery);
                if (itemMinQtyResult?.length) {
                    itemQty = itemMinQtyResult[0].minimumQty;
                }
                minMaintainableStockQty.set(itemCode, itemQty);
                // please ensure the db selects and the prototyped objects are in same casing {physicalQuantity: number}
                const stockQuery = `SELECT physical_quantity as physicalQuantity from ` + appSettings.procure_db + `.stock s where item_id=${bomData.itemId} and saleOrder_id=0 and unit_id=${bomData.saleOrderInfo.SoInvDetailsInfo.processingUnit}`;
                const availableStockResult: { physicalQuantity: number }[] = await manager.query(stockQuery);
                let stockQty = 0;
                if (availableStockResult?.length) {
                    stockQty = availableStockResult[0].physicalQuantity;
                }
                itemCodeCurrStockAtSameUnit.set(itemCode, stockQty);
            }
            let availableQty = itemCodeCurrStockAtSameUnit.get(itemCode);
            const minQty = minMaintainableStockQty.get(itemCode);
            // Example
            // po      = 24000
            // avl     = 25000
            // min     = 1000
            const currMaterialIsInReq = bomReq.packingMaterialId.includes(currPackingMaterialId);
            if (availableQty - minQty >= poQty) {
                availableQty -= poQty;
                poQty = 0;
                atLeastOneItemAllocatedFromStock = true;
            } else {
                poQty = poQty - (availableQty - minQty);
                availableQty = 0;
            }
            itemCodeCurrStockAtSameUnit.set(itemCode, availableQty > 0 ? availableQty : 0);
            // console.log(poQty + ' === ' + itemCodeCurrStockAtSameUnit.get(itemCode));
            // After doing all cutoffs , only if the packing id is in the incoming request, only then we have to allocate the BOM to it. else skip it
            if (poQty > 0 && currMaterialIsInReq) {
                await Promise.all([itemCategoryDetails, itemDetails, sizeDetails, itemSubCategoryDetails]).then(res => {
                    const bom = new BomPackingItemsForSO((res[0]) ? res[0] : null, (res[1]) ? res[1] : null, (res[3]) ? res[3] : null, (res[2]) ? res[2] : null, poQty, bomData.status, bomData.packingMaterialId, bomData.createdUser, bomData.saleOrderId, bomData.updatedUser, bomData.packingCategory, bomData.isActive,
                        null, bomData.requiredQuantity, bomData.receivedQuantity, bomData.AssignedQuantity, bomData.poQty, bomData.saleOrderInfo.saleOrderNumber + " - " + bomData.saleOrderInfo.SoInvDetailsInfo.poNumber);
                    bomDataForSaleOrder.push(bom);
                });
            }
        }
        if (bomDataForSaleOrder.length) {
            return new BomDetailsForIdResponseModel(true, 1111, 'Bom Details Found For Sale Order', bomDataForSaleOrder);
        } else if (poQty > 0 && atLeastOneItemAllocatedFromStock) {
            return new BomDetailsForIdResponseModel(false, 9999, 'Sufficient stock is available in the inventory for some material requests in the PO', bomDataForSaleOrder)
        } else {
            return new BomDetailsForIdResponseModel(false, 9999, 'Po Already Created For bom Items For Selected SO', bomDataForSaleOrder);
        }
    }

    async getAllBomDetailsBySoId(saleOrderId: number): Promise<ItemCategoriesDropDownResponseModel> {
        try {
            const bomDetails = this.bomRepo.createQueryBuilder("BomDetails")
                .select(["BomDetails.item_category_id as itemCategoryId"])
                .where("BomDetails.sale_order_id=" + saleOrderId)
                .groupBy('BomDetails.itemCategoryId')
            const ItemCategoryDropDown = await bomDetails.getRawMany();
            console.log(ItemCategoryDropDown);
            if (ItemCategoryDropDown) {
                const itemCategory: ItemCategoryDropDownDto[] = [];
                for (const itemCatId of ItemCategoryDropDown) {
                    const itemCategoryReq = new ItemCategoryReq(itemCatId.itemCategoryId);
                    const itemCategoryDetails = await this.CategoryService.getItemCategoryById(itemCategoryReq);
                    const data = new ItemCategoryDropDownDto(itemCategoryDetails.itemCategoryId, itemCategoryDetails.itemCategoryCode, itemCategoryDetails.itemCategory, saleOrderId)
                    itemCategory.push(data)
                    if (!itemCategoryDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item Category');
                    }
                }
                return new ItemCategoriesDropDownResponseModel(true, 1111, 'Item Categories retrived Successfully.', itemCategory);
            } else {
                throw new ErrorResponse(9999, 'No data Found')
            }
        } catch (error) {
            return error;
        }
    }


    async getAllBomDetailViewDataForSoId(saleOrderIdRequest: SaleOrderIdRequest): Promise<BOMDetailViewResponse> {
        try {
            // console.log('saleOrderIdRequest'+saleOrderIdRequest);
            const bomDetails = await this.bomRepo.BomDetailsForSo(saleOrderIdRequest);
            const bomDataForSaleOrder: BomInfoForDetailView[] = [];
            if (bomDetails) {
                for (const bomData of bomDetails) {
                    // get item category details for item category id
                    const itemCategoryReq = new ItemCategoryReq(bomData.itemCategoryId);
                    const itemCategoryDetails = this.CategoryService.getItemCategoryById(itemCategoryReq);
                    if (!itemCategoryDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item Category');
                    }

                    // get item details for item id 
                    const itemReq = new ItemRequest(bomData.itemId);
                    const itemDetails = this.itemService.getItemById(itemReq);
                    if (!itemDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item');
                    }

                    const size = new SizeRequest(bomData.size);
                    const sizeDetails = this.sizeService.getSizeDataById(size);
                    if (!size) {
                        throw new ErrorResponse(1111, 'Failed to Get Size');
                    }

                    const so = new SOInfoReq(bomData.saleOrderInfo.saleOrderId, bomData.saleOrderInfo.saleOrderNumber)
                    await Promise.all([itemCategoryDetails, itemDetails, sizeDetails]).then(res => {
                        const bom = new BomInfoForDetailView((res[0]) ? res[0] : null, (res[1]) ? res[1] : null, (res[2]) ? res[2] : null, bomData.quantity, so);
                        bomDataForSaleOrder.push(bom);
                    })
                }
                return new BOMDetailViewResponse(true, 1111, 'Bom Details Found For Sale Order', bomDataForSaleOrder);
            } else {
                throw new ErrorResponse(9999, 'No data Found')
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async updateBomStats(req: BomIdRequest): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            const bomInfo = await manager.getCustomRepository(BomRepository).createQueryBuilder('bom').select('packing_category as category, required_qty as rQty, po_qty as poQty, quantity as qty').where(`packing_material_id=${req.packingMaterialId}`).getRawOne();
            let qty = bomInfo.qty;
            let rQty = bomInfo.rQty;
            if (bomInfo.category == 'Added In PO') {
                if (rQty < req.poQty) {
                    rQty = req.poQty;
                    qty = req.poQty;
                }
            }

            const updateStatus = await manager.getCustomRepository(BomRepository).update({ packingMaterialId: Raw(alias => `packing_material_id = '${req.packingMaterialId}'`) }, { status: StatusEnum.PO, poQty: req.poQty, requiredQuantity: rQty, quantity: qty, itemId: req.itemId });

            if (updateStatus.affected) {
                await manager.completeTransaction();
                return new CommonResponse(true, 1111, 'Bom Info Updated Successfully');
            } else {
                throw new ErrorResponse(9999, 'Failed To Update');
            }
        } catch (error) {
            await manager.releaseTransaction();
            return error;
        }
    }

    async updatePackingBOMPOData(req: BomUpdateRequest): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        const packingBOMDetails = await this.packingBomLogRepo.createQueryBuilder("PackingBomLog").select(['po_quantity as poQuantity,quantity,packing_bom_log_id as bomLogId']).where("sale_order_id=" + req.saleOrderId + " and item_id=" + req.itemId + " and po_quantity < quantity").orderBy('packing_bom_log_id', 'ASC').getRawMany()
        await manager.startTransaction();
        if (packingBOMDetails.length > 0) {
            const setFlag = new Set<boolean>()
            for (const bomitem of packingBOMDetails) {
                if (req.acceptedQuantity >= 0 && (Number(bomitem.quantity) - Number(bomitem.poQuantity)) <= Number(req.acceptedQuantity)) {
                    const updateStatus = await manager.getCustomRepository(PackingBomLogRepository).update({ bomLogId: bomitem.bomLogId }, { status: PackingBOMStatusEnum.PO, poQuantity: bomitem.quantity })
                    if (updateStatus.affected) {
                        req.acceptedQuantity = req.acceptedQuantity - (bomitem.quantity - bomitem.poQuantity)
                        setFlag.add(true)
                    } else {
                        setFlag.add(false)
                    }
                } else {
                    if ((bomitem.quantity - bomitem.poQuantity) > req.acceptedQuantity) {
                        const updatePartialQty = await manager.getCustomRepository(PackingBomLogRepository).update({ bomLogId: bomitem.bomLogId }, { status: PackingBOMStatusEnum.PO, poQuantity: () => `po_quantity+${req.acceptedQuantity}` })
                        if (updatePartialQty.affected) {
                            setFlag.add(true)
                        } else {
                            setFlag.add(false)
                        }
                        break;
                    }
                    // const updateqty = await this.packingBomLogRepo.update()
                }
            }
            if (!setFlag.has(false)) {
                await manager.completeTransaction();
                return new CommonResponse(true, 5555, 'po details for BOM updated')
            } else {
                await manager.releaseTransaction();
                return new CommonResponse(false, 1111, 'bom log not updated')
            }
        } else {
            await manager.releaseTransaction();
            throw new ErrorResponse(9999, 'Failed To Update');
        }

    }

    async updatePackingBOMGRNData(req: BomUpdateRequest): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        const packingBOMDetails = await this.packingBomLogRepo.createQueryBuilder("PackingBomLog").select(['po_quantity as poQuantity,quantity,packing_bom_log_id as bomLogId,grn_quantity as grnQty']).where("sale_order_id=" + req.saleOrderId + " and item_id=" + req.itemId + " and grn_quantity < quantity").orderBy('packing_bom_log_id', 'ASC').getRawMany()
        await manager.startTransaction();
        if (packingBOMDetails.length > 0) {
            const setFlag = new Set<boolean>()
            let varIndex = 0
            for (const [index, bomitem] of packingBOMDetails.entries()) {
                if (req.acceptedQuantity >= 0 && (Number(bomitem.quantity) - Number(bomitem.grnQty)) <= Number(req.acceptedQuantity)) {
                    let tobeupdatedGrnQty = bomitem.quantity
                    if (packingBOMDetails.length - 1 == Number(index)) {
                        tobeupdatedGrnQty = Number(bomitem.grnQty) + Number(req.acceptedQuantity)
                    }
                    const updateStatus = await manager.getCustomRepository(PackingBomLogRepository).update({ bomLogId: bomitem.bomLogId }, { status: PackingBOMStatusEnum.GRN, isGrn: true, grnQuantity: tobeupdatedGrnQty })
                    if (updateStatus.affected) {
                        req.acceptedQuantity = req.acceptedQuantity - (bomitem.quantity - bomitem.grnQty)
                        setFlag.add(true)
                        // await manager.completeTransaction();
                    } else {
                        setFlag.add(false)
                    }
                } else {
                    if ((bomitem.quantity - bomitem.grnQty) > req.acceptedQuantity) {
                        const updatePartialQty = await manager.getCustomRepository(PackingBomLogRepository).update({ bomLogId: bomitem.bomLogId }, { status: PackingBOMStatusEnum.GRN, isGrn: true, grnQuantity: () => `grn_quantity+${req.acceptedQuantity}` })
                        if (updatePartialQty.affected) {
                            setFlag.add(true)
                        } else {
                            setFlag.add(false)
                        }
                        break;
                    }
                    // const updateqty = await this.packingBomLogRepo.update()
                }
                // varIndex = Number(varIndex)+1;
            }
            if (!setFlag.has(false)) {
                await manager.completeTransaction();
                return new CommonResponse(true, 5555, 'GRN details for BOM updated')
            } else {
                await manager.releaseTransaction();
                return new CommonResponse(false, 1111, 'GRN of bom log not updated')
            }
        } else {
            const packingBOMDetails = await this.packingBomLogRepo.createQueryBuilder("PackingBomLog").select(['po_quantity as poQuantity,quantity,packing_bom_log_id as bomLogId,grn_quantity as grnQty']).where("sale_order_id=" + req.saleOrderId + " and item_id=" + req.itemId + " and grn_quantity >= quantity").orderBy('packing_bom_log_id', 'ASC').getRawOne()
            console.log('packingBOMDetails')
            console.log(packingBOMDetails)
            if (packingBOMDetails) {
                const updatePartialQty = await manager.getCustomRepository(PackingBomLogRepository).update({ bomLogId: packingBOMDetails.bomLogId }, { status: PackingBOMStatusEnum.GRN, isGrn: true, grnQuantity: () => `grn_quantity+${req.acceptedQuantity}` })
                if (updatePartialQty.affected) {
                    await manager.completeTransaction();
                    return new CommonResponse(true, 1111, 'GRN of bom log not updated')
                } else {
                    await manager.releaseTransaction();
                    return new CommonResponse(false, 1111, 'GRN of bom log not updated')
                }
            } else {
                await manager.releaseTransaction();
                return new CommonResponse(false, 1111, 'GRN of bom log not updated')
            }
        }

    }

    async updatePackingBOMAssignedData(req: BomUpdateRequest): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        const packingBOMDetails = await this.packingBomLogRepo.createQueryBuilder("PackingBomLog").select(['po_quantity as poQuantity,quantity,packing_bom_log_id as bomLogId,grn_quantity as grnQty,assigned_quantity as assignedQty']).where("sale_order_id=" + req.saleOrderId + " and item_id=" + req.itemId + " and assigned_quantity < quantity").orderBy('packing_bom_log_id', 'ASC').getRawMany()
        await manager.startTransaction();
        if (packingBOMDetails.length > 0) {
            const setFlag = new Set<boolean>()
            let varIndex = 0
            for (const [index, bomitem] of packingBOMDetails.entries()) {
                if (req.acceptedQuantity >= 0 && (Number(bomitem.quantity) - Number(bomitem.assignedQty)) <= Number(req.acceptedQuantity)) {
                    let tobeupdatedAssignedQty = bomitem.quantity
                    if (packingBOMDetails.length - 1 == Number(index)) {
                        tobeupdatedAssignedQty = Number(bomitem.assignedQty) + Number(req.acceptedQuantity)
                    }
                    const updateStatus = await manager.getCustomRepository(PackingBomLogRepository).update({ bomLogId: bomitem.bomLogId }, { status: PackingBOMStatusEnum.BULK, isAssigned: true, grnQuantity: tobeupdatedAssignedQty })
                    if (updateStatus.affected) {
                        req.acceptedQuantity = req.acceptedQuantity - (bomitem.quantity - bomitem.assignedQty)
                        setFlag.add(true)
                        // await manager.completeTransaction();
                    } else {
                        setFlag.add(false)
                    }
                } else {
                    if ((bomitem.quantity - bomitem.assignedQty) > req.acceptedQuantity) {
                        const updatePartialQty = await manager.getCustomRepository(PackingBomLogRepository).update({ bomLogId: bomitem.bomLogId }, { status: PackingBOMStatusEnum.BULK, isAssigned: true, assignedQuantity: () => `assigned_quantity+${req.acceptedQuantity}` })
                        if (updatePartialQty.affected) {
                            setFlag.add(true)
                        } else {
                            setFlag.add(false)
                        }
                        break;
                    }
                    // const updateqty = await this.packingBomLogRepo.update()
                }
                // varIndex = Number(varIndex)+1;
            }
            if (!setFlag.has(false)) {
                await manager.completeTransaction();
                return new CommonResponse(true, 5555, 'GRN details for BOM updated')
            } else {
                await manager.releaseTransaction();
                return new CommonResponse(false, 1111, 'GRN of bom log not updated')
            }
        } else {
            await manager.releaseTransaction();
            throw new ErrorResponse(9999, 'Failed To Update');
        }

    }


    async ActivateorDeactivateBom(req: BomIdRequest): Promise<BomItemActiveResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            const bomInfo = await manager.getCustomRepository(BomRepository).createQueryBuilder('bom').select('packing_category as category, required_qty as rQty, po_qty as poQty, quantity as qty').where(`packing_material_id=${req.packingMaterialId}`).getRawOne();
            let updateStatus;
            if (bomInfo.category == 'Added In PO' || !req.fromPo) {
                updateStatus = await manager.getCustomRepository(BomRepository).update({ packingMaterialId: Raw(alias => `packing_material_id = '${req.packingMaterialId}'`) }, { isActive: req.isActive });
            } else {
                updateStatus = await manager.getCustomRepository(BomRepository).update({ packingMaterialId: Raw(alias => `packing_material_id = '${req.packingMaterialId}'`) }, { poQty: () => `po_qty-${req.poQty}` });
            }


            if (updateStatus.affected) {
                manager.completeTransaction();
                return new BomItemActiveResponse(true, 1111, req.isActive ? 'Item Activated Successfully' : 'Item De Activated Successfully');
            } else {
                throw new ErrorResponse(9999, 'Failed To Update')
            }
        } catch (error) {
            await manager.releaseTransaction();
            return error;
        }

    }

    async UpdateBomItemsData(req: UpdateBomItemDto) {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            const updateStatus = await manager.getCustomRepository(BomRepository).update({ packingMaterialId: Raw(alias => `packing_material_id = '${req.packingMaterialId}'`) }, { quantity: req.quantity, requiredQuantity: req.toBeProcured });
            if (updateStatus.affected) {
                await manager.completeTransaction();
                return new BomItemActiveResponse(true, 1111, 'Updated Details Successfully');
            } else {
                throw new ErrorResponse(9999, 'Something Went Wrong');
            }
        } catch (err) {
            await manager.releaseTransaction();
            return err;
        }

    }

    async UpdateBomRemovedQty(req: BomItemRemovedQty) {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            const bomData = await manager.getCustomRepository(BomRepository).findOne({ select: ['requiredQuantity', 'receivedQuantity', 'status', 'AssignedQuantity'], where: { saleOrderId: req.saleOrderId, itemId: req.itemId } })
            let bomStatus = StatusEnum.OPEN;
            if (Number(bomData.receivedQuantity) > 0) {
                bomStatus = StatusEnum.GRN;
            }
            if (Number(bomData.AssignedQuantity) - Number(req.removedQuantity) > 0) {
                bomStatus = StatusEnum.ASSIGNED;
            }
            const updateBom = await manager.getCustomRepository(BomRepository).update({ packingMaterialId: req.packingMaterialId }, { requiredQuantity: () => `required_qty+${req.removedQuantity}`, AssignedQuantity: () => `assigned_qty-${req.removedQuantity}`, status: bomStatus });

            if (updateBom.affected) {
                console.log('afected and ')
                const stockData = await this.stockService.updateRemovedAssignedQtyForSo(req);
                if (stockData.status) {
                    const response = await this.saleService.UpdateSoTrackerStatus({ saleOrderId: req.saleOrderId, itemId: req.itemId, acceptedQuantity: req.removedQuantity });
                    if (response) {
                        await manager.completeTransaction();
                        return new BomItemActiveResponse(true, 1111, 'Updated Details Successfully');
                    } else {
                        throw new ErrorResponse(9999, 'Failed to update stock');
                    }
                } else {
                    throw new ErrorResponse(9999, 'Failed to update stock');
                }
            } else {
                throw new ErrorResponse(9999, 'Something Went Wrong');
            }
        } catch (err) {
            await manager.releaseTransaction();
            return err;
        }

    }

    async getReProcessingRequiredQuantity(req: ReProcessRequiredQty) {
        const bomDetails = await this.bomRepo.getReProcessingRequiredQuantity(req.saleOrderId);
        let requiredQty: number = 0;
        if (bomDetails && bomDetails.length > 0) {
            for (const bomItem of bomDetails) {
                const itemReq = new GetItemForProductRequest(bomItem.itemId, req.productId);
                const itemInfo = await this.itemService.getItemForProduct(itemReq);
                console.log(itemInfo);
                if (itemInfo) {
                    requiredQty = Number(requiredQty) + (Number(bomItem.quantity) > Number(bomItem.AssignedQuantity) ? (Number(bomItem.quantity) - Number(bomItem.AssignedQuantity)) : 0);
                }
            }
        }
        return requiredQty;
    }

    async updateReProcessQty(reProcessStock: FGStockData) {
        console.log(reProcessStock);
        const manager = new GenericTransactionManager();
        try {
            const bomDetails = await this.bomRepo.getReProcessingRequiredQuantity(reProcessStock.assignedSoId);
            let requiredQty: number = 0;
            if (bomDetails && bomDetails.length > 0) {
                for (const bomItem of bomDetails) {
                    const itemReq = new GetItemForProductRequest(bomItem.itemId, reProcessStock.productId);
                    const itemInfo = await this.itemService.getItemForProduct(itemReq);

                    if (itemInfo) {
                        await manager.startTransaction();
                        const updateBom = await manager.getCustomRepository(BomRepository).update({ packingMaterialId: bomItem.packingMaterialId }, { requiredQuantity: () => `required_qty-${reProcessStock.assigningQty}`, AssignedQuantity: () => `assigned_qty+${reProcessStock.assigningQty}` });
                        if (updateBom.affected) {
                            console.log("*Bom Updated*");
                            await manager.completeTransaction();
                            return new BomItemActiveResponse(true, 1111, 'Updated Details Successfully');
                        } else {
                            throw new ErrorResponse(9999, 'Something Went Wrong');
                        }
                    }
                }
            }
        } catch (error) {
            manager.releaseTransaction();
            return error;
        }
    }

    async packingRequirementForMonthly(): Promise<PackingRequiredResponse> {
        try {
            const bomDetails = await this.bomRepo.packingRequirementForMonthly();
            const series: Series[] = []
            const categories: string[] = [];
            if (bomDetails.data && bomDetails.data.length) {
                for (const data of bomDetails.packingCat) {
                    const ser = new Series();
                    ser.name = data.packingCategory;

                    const details: number[] = [];
                    let ifNoData = true;
                    let category;
                    for (const mon of bomDetails.months) {
                        ifNoData = true;
                        for (const dataInfo of bomDetails.data) {
                            if (mon.month == dataInfo.month && data.packingCategory == dataInfo.packingCategory) {
                                ifNoData = false;
                                details.push(Number(dataInfo.requiredQuantity));
                            }
                        }
                        if (ifNoData) {
                            details.push(0);
                        }

                    }

                    ser.data = details;
                    series.push(ser);
                }
                for (const mon of bomDetails.months) {
                    categories.push(mon.month);
                }
            } else {
                return new PackingRequiredResponse(false, 999, 'No Data Found')
            }

            const chartData = new ChartInfo();
            chartData.data = series;
            chartData.xaxis = categories
            return new PackingRequiredResponse(true, 11111, 'Data Found', chartData);
        } catch (error) {
            return error;
        }
    }


    async PackingBomData(req: PackingBomFilter): Promise<RequiredPackingResponse> {
        const manager = getManager();
        try {
            let bomQuery = `SELECT u.unit_name as unitName, mb.brand_name as brandName, soi.po_number as poNumber, i.item_name as itemName, i.packing_category as Category, bom.required_qty as requiredQty, bom.po_qty as poQty, bom.receiced_qty as receivedQty, bom.assigned_qty as assignQty, DATE_FORMAT(soi.edl_date, "%d-%m-%Y") as etd, bom.quantity as quantity, e.end_customer_name as endCustomerName, bom.item_id as itemId, i.min_qnty as minQnty, soi.processing_unit as unitId, bom.sale_order_id as saleOrderId, bom.packing_material_id as bomId FROM ` + appSettings.sales_db + `.sale_order so  
            LEFT JOIN `+ appSettings.sales_db + `.bom_details bom ON bom.sale_order_id = so.sale_order_id 
            LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id= bom.item_id 
            LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details soi ON soi.sale_order_id = so.sale_order_id  
            LEFT JOIN `+ appSettings.masters_db + `.unitcodes u  ON u.unit_code_id = soi.processing_unit 
            LEFT JOIN `+ appSettings.masters_db + `.master_brands mb  ON mb.master_brand_id = i.brand 
            LEFT JOIN `+ appSettings.masters_db + `.end_customers e  ON e.end_customer_id = soi.end_customer_id 
            WHERE bom.packing_category is not null and (bom.quantity - (po_qty+assigned_qty)) > 0 and so.status<>'CLOSED'`;

            if (req?.itemName) {
                bomQuery += ` and bom.item_id=${req.itemName}`;
            }


            if (req?.saleOrderIds?.length) {
                bomQuery += ` and bom.sale_order_id IN (${req.saleOrderIds})`;
            }

            if (req.unitId) {
                bomQuery += ` and soi.processing_unit =${req.unitId}`;
            }
            if (req.unitId && req.unitId != 5) {
                bomQuery += ` and soi.processing_unit=` + req.unitId;
            }

            if (req.endCustomerId) {
                bomQuery += ` and soi.end_customer_id =${req.endCustomerId}`;
            }
            if (req.itemSubCategoryId) {
                bomQuery += ` and bom.item_sub_category_id=${req.itemSubCategoryId}`
            }

            bomQuery += ` group by soi.factoryId, e.end_customer_id, so.sale_order_id, bom.item_id order by u.unit_name, soi.end_customer_id,soi.edl_date`;

            const requiredBom = await manager.query(bomQuery);
            const newMap = new Map<string, any[]>();
            const requiredMap = new Map<string, Map<string, any[]>>();
            // construct object array


            const itemSameLocStockQtyMap = new Map<number, number>();
            const itemOtherLocStockQtyMap = new Map<number, number>();
            requiredBom.forEach((record) => {
                if (!(newMap.has(record.unitName))) {
                    const dataArray: any[] = [];
                    dataArray.push(record);
                    newMap.set(record.unitName, dataArray);
                } else {
                    newMap.get(record.unitName).push(record);
                }

                if (!(requiredMap.has(record.unitName))) {
                    const dataArray: any[] = [];
                    dataArray.push(record);
                    requiredMap.set(record.unitName, new Map<string, any[]>());
                    if (!(requiredMap.get(record.unitName).has(record.endCustomerName + record.itemId))) {
                        requiredMap
                            .get(record.unitName)
                            .set(record.endCustomerName + record.itemId, dataArray);
                    }
                } else {
                    const dataArray: any[] = [];
                    dataArray.push(record);
                    if (!(requiredMap.get(record.unitName).has(record.endCustomerName + record.itemId))) {
                        requiredMap
                            .get(record.unitName)
                            .set(record.endCustomerName + record.itemId, dataArray);
                    } else {
                        requiredMap
                            .get(record.unitName).get(record.endCustomerName + record.itemId).push(record)
                    }
                }
            });



            const newObj = [...newMap];
            const requiredArray = [...requiredMap];

            const units: UnitsRequiredBomInfo[] = [];
            for (const arr of requiredArray) {
                let unitRowSpan = 0;
                const unit = new UnitsRequiredBomInfo();
                unit.unitName = arr[0];
                const customers: CustomersInfo[] = [];
                const customersArray = [...arr[1]];
                for (const [key, value] of customersArray) {

                    let itemId = 0;
                    let unitId = 0;
                    const customer = new CustomersInfo();
                    customer.totalQty = 0;
                    customer.totalRequiredQty = 0;
                    customer.totalPoQty = 0;
                    customer.totalGrnQty = 0;
                    customer.totalAssignedQty = 0;
                    let customerRowSpan = 0;
                    let customerName = '';
                    const orders: OrderInfo[] = [];
                    for (const o of value) {
                        const order = new OrderInfo();
                        order.brandName = o.brandName;
                        order.poNumber = o.poNumber;
                        order.itemName = o.itemName;
                        order.etd = o.etd;
                        order.quantity = o.quantity;
                        order.requiredQty = o.requiredQty;
                        order.poQty = o.poQty;
                        order.receivedQty = o.receivedQty;
                        order.assignQty = o.assignQty;
                        order.minQnty = o.minQnty;
                        order.unitId = o.unitId;
                        order.itemId = o.itemId;
                        order.bomId = o.bomId;
                        order.saleOrderId = o.saleOrderId;
                        unitId = o.unitId;
                        itemId = o.itemId;
                        customer.totalQty += Number(o.quantity);
                        customer.totalRequiredQty += Number(o.requiredQty);
                        customer.totalPoQty += Number(o.poQty);
                        customer.totalGrnQty += Number(o.receivedQty);
                        customer.totalAssignedQty += Number(o.assignQty);
                        customerName = o.endCustomerName;
                        orders.push(order);
                        unitRowSpan++;
                        customerRowSpan++;
                    }

                    if (!itemSameLocStockQtyMap.has(itemId)) {
                        // get item available qty from stock current Plant
                        const stockQuery = `SELECT physical_quantity as physicalQuantity from ` + appSettings.procure_db + `.stock s where item_id=${itemId} and saleOrder_id=0 and unit_id=${unitId}`;
                        const availableStock: { physicalQuantity: number }[] = await manager.query(stockQuery);
                        let availableStockQty = 0;
                        if (availableStock?.length) {
                            availableStockQty = availableStock[0].physicalQuantity;
                        }
                        itemSameLocStockQtyMap.set(itemId, availableStockQty);

                        // get item available qty from stock other plants
                        const otherUnitQuery = `SELECT physical_quantity as physicalQuantity from ` + appSettings.procure_db + `.stock s where item_id=${itemId} and saleOrder_id=0 and unit_id!=${unitId}`;
                        const otherStock: { physicalQuantity: number }[] = await manager.query(otherUnitQuery);
                        let otherStockQty = 0;
                        if (otherStock?.length) {
                            otherStockQty = otherStock[0].physicalQuantity;
                        }
                        itemOtherLocStockQtyMap.set(itemId, otherStockQty);
                    }
                    const availableSameLocStockQty = itemSameLocStockQtyMap.get(itemId);
                    const availableOtherLocStockQty = itemOtherLocStockQtyMap.get(itemId);
                    customer.customerName = customerName;
                    customer.children = orders;
                    customer.rowSpan = customerRowSpan;
                    customer.availableQty = Number(availableSameLocStockQty) || 0;
                    customer.othersAvailableQty = Number(availableOtherLocStockQty) || 0;
                    customers.push(customer);
                }
                unit.children = customers;
                unit.rowSpan = unitRowSpan;
                units.push(unit);
            }

            const repo = new RequiredPackingResponse(true, 1111, 'Data Found', units);
            // const newLogDto = new LogsDto(1,'view packing bom', 'PackingBomFilter', 0, true, '','')
            // let res = await this.logService.createLog(newLogDto);
            // console.log(res);
            return repo
        } catch (error) {
            return error;
        }
    }

    async getSoPackingStatus(req?: SoPackingStatusRequest): Promise<CommonResponse> {
        console.log(req, 'req')
        try {
            const manager = getManager();
            let query = `SELECT bd.packing_category as packingSubCategory, bd.quantity as requiredQty, bd.receiced_qty as receivedQty, bd.assigned_qty as assignedQty, bd.po_qty as poQty,bd.sale_order_id as saleOrderId,si.po_number as saleOrderNo , bd.item_id as itemId,i.item_name as item,bd.item_sub_category_id as itemSubCategoryId,sci.quantity as issuedQty,sr.return_quantity as returnedQty,if(bd.packing_category = 'Pouch',(soi.reported_cases*soi.pouches), soi.reported_cases) as fgQty, s.physical_quantity as availableQty,u.unit_name as unitName, si.act_edl_date as etd,((bd.assigned_qty + sr.return_quantity + sci.quantity)-((bd.po_qty)-if(bd.packing_category = 'Pouch',(soi.reported_cases*soi.pouches), soi.reported_cases))-(sci.quantity-(if(bd.packing_category = 'Pouch',(soi.reported_cases*soi.pouches), soi.reported_cases))-sr.return_quantity)) as balance  FROM ` + appSettings.sales_db + `.bom_details bd 
            LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = bd.item_id
            LEFT JOIN ` + appSettings.procure_db + `.store_consumption sc ON sc.sale_order_id = bd.sale_order_id
            LEFT JOIN ` + appSettings.procure_db + `.store_consumption_items sci ON sc.store_consumption_id = sci.store_consumption_id 
            LEFT JOIN ` + appSettings.sales_db + `.sale_order_items soi ON bd.sale_order_id = soi.sale_order_id 
            LEFT JOIN ` + appSettings.procure_db + `.store_return sr ON sr.sale_order_id = bd.sale_order_id
            LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = bd.sale_order_id
            LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id = bd.sale_order_id
            LEFT JOIN ` + appSettings.procure_db + `.stock s ON s.saleOrder_id = bd.sale_order_id   
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = si.processing_unit
            WHERE bd.item_category_id=6  and so.so_process_type = 'MTO' and so.so_type = 'Dispatch'`
            if (req.saleOrderId && req.saleOrderId.length) {
                console.log(req.saleOrderId, '--soId--')
                query = query + ' and bd.sale_order_id IN (' + req.saleOrderId.toString() + ')';
            }
            if (req.unitId) {
                query = query + ' and si.processing_unit = ' + req.unitId;
            }
            if (req.itemSubCategoryId) {
                console.log(req.itemSubCategoryId)
                query = query + ' and bd.item_sub_category_id = "' + req.itemSubCategoryId + `"`
            }
            if (req.fromDate != undefined) {
                query = query + ' and si.act_edl_date between  "' + req.fromDate + '" and "' + req.toDate + '"';
            }
            if (req.itemNameId) {
                query = query + ' and i.item_id = ' + req.itemNameId;
            }
            query = query + ` GROUP BY bd.sale_order_id, bd.item_id `
            console.log(query);
            const data = await manager.query(query)
            if (data.length > 0) {
                const response = new CommonResponse(true, 11208, "So Packing Status retrieved successfully", data);
                return response;
            } else {
                throw new CommonResponse(false, 99998, 'No Record Found');
            }
        } catch (err) {
            return err
        }
    }
    async getSoDropForSoPackStatusReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT bd.sale_order_id AS saleOrderId , si.po_number AS saleOrderNo , si.processing_unit from ` + appSettings.sales_db + `.bom_details bd
        left join ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = bd.sale_order_id
        left join ` + appSettings.procure_db + `.stock s ON s.saleorder_id = bd.sale_order_id
        LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id = bd.sale_order_id
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = si.processing_unit
        WHERE bd.item_category_id=6 and so.so_process_type = 'MTO' and so.so_type = 'Dispatch'AND bd.sale_order_id> 0 AND si.processing_unit> 0` ;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and si.processing_unit = ' + req.unitId;
        }
        query = query + ` GROUP BY si.po_number  ORDER BY saleOrderNo `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1111, 'Data retrieve successfully', data)
        } else {
            return new CommonResponse(false, 1111, 'No data')
        }
    }

    async getItemSubDropForSoPackStatusReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT bd.item_sub_category_id AS itemSubCategoryId , iis.item_sub_category AS itemSubCategory, si.processing_unit  from ` + appSettings.sales_db + `.bom_details bd
        left join ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = bd.sale_order_id 
        left join ` + appSettings.masters_db + `.item_sub_categories iis ON iis.item_sub_category_id = bd.item_sub_category_id
        LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id = bd.sale_order_id
        WHERE bd.item_sub_category_id> 0 AND bd.item_category_id=6 AND iis.item_sub_category IS NOT NULL and so.so_process_type = 'MTO' and so.so_type = 'Dispatch'` ;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and si.processing_unit = ' + req.unitId;
        }
        query = query + ` GROUP BY bd.item_sub_category_id  ORDER BY itemSubCategory `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1141, 'Data retrieve successfully', data)
        } else {
            return new CommonResponse(false, 1141, 'No data')
        }
    }
    async getItemDropForSoPackStatusReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT bd.item_id AS itemNameId,i.item_name AS item ,si.processing_unit from ` + appSettings.sales_db + `.bom_details bd
        left join ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = bd.sale_order_id 
        left join ` + appSettings.masters_db + `.items i ON i.item_id = bd.item_id
        LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id = bd.sale_order_id
        WHERE bd.item_id> 0 AND i.item_name IS NOT NULL AND bd.item_category_id=6 and so.so_process_type = 'MTO' and so.so_type = 'Dispatch'` ;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and si.processing_unit = ' + req.unitId;
        }
        query = query + ` GROUP BY bd.item_id  ORDER BY item `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1141, 'Data retrieve successfully', data)
        } else {
            return new CommonResponse(false, 1141, 'No data')
        }
    }

    async getDummyItemsForStoreConsumption(unitReq: UnitRequest): Promise<ItemsDetailsResponseModel> {
        try {
            const manager = getManager();
            const query = `select s.item_id as itemId,i.item_name as itemName,s.physical_quantity as physicalQuantity from ` + appSettings.procure_db + `.stock s left join ` + appSettings.masters_db + `.items i on i.item_id = s.item_id where s.saleorder_id = 0 and s.physical_quantity > 0 and s.unit_id = ` + unitReq.unitId + ` group by s.item_id`

            const data = await manager.query(query)
            if (data) {
                return new ItemsDetailsResponseModel(true, 1141, 'Data retrieve successfully', data)
            } else {
                return new CommonResponse(false, 1141, 'No data')
            }

        } catch (error) {
            return error
        }
    }

    async getItemsForStoreConsumption(req: StoreConsumptionItemsRequest): Promise<ItemsDetailsResponseModel> {
        try {
            const manager = getManager();
            let query = `select ps.item_id as itemId,i.item_name as itemName,s.physical_quantity as physicalQuantity,ps.stock_id as stockId from ` + appSettings.procure_db + `.prepared_stock ps left join ` + appSettings.procure_db + `.stock s on s.stock_id = ps.stock_id left join ` + appSettings.masters_db + `.items i on i.item_id = ps.item_id where ps.sale_order_id = ` + req.saleOrderId + ` and ps.sale_order_item_id = ` + req.saleOrderItemId + ` and ps.unit_id = ` + req.unitId + ` group by ps.sale_order_item_id,ps.item_id`


            const data = await manager.query(query)
            if (data) {
                return new ItemsDetailsResponseModel(true, 1141, 'Data retrieve successfully', data)
            } else {
                return new CommonResponse(false, 1141, 'No data')
            }

        } catch (error) {
            return error
        }
    }

    async getRequiredPMQtyForSoItem(req: StoreConsumptionItemQtyReq): Promise<CommonResponse> {
        const manager = getManager()
        const query = `select quantity as requiredQuantity from ${appSettings.sales_db}.packing_bom_log where sale_order_item_id = ${req.saleOrderItemId} and item_id = ${req.itemId} `
        const preparedMaterialQty = `select prepared_quantity as preparedQuantity from ${appSettings.procure_db}.prepared_stock where sale_order_item_id = ${req.saleOrderItemId} and item_id = ${req.itemId}`
        const data = await manager.query(query)
        const dataTwo = [{ preparedQuantity: 200 }]
        await manager.query(preparedMaterialQty)
        console.log(data, dataTwo)
        const quantities = [...data, ...dataTwo]
        console.log(quantities)
        if (data && data.length > 0) {
            return new CommonResponse(true, 1111, 'Quantity retreived sucessfully', quantities)
        } else {
            return new CommonResponse(false, 1141, 'No data')

        }

    }

    // async updateProductConversionQty(req: ProductConversionReq): Promise<CommonResponse> {
    //     console.log('herereqqq',req)
    //     let updateToBom
    //     const updateFRomSoBom = await this.bomRepo.update({ saleOrderId: req.saleOrderId, itemId: req.itemId }, { receivedQuantity: () => `receiced_qty-${req.qty}`,status:StatusEnum.OPEN,requiredQuantity: () => `required_qty+${req.qty}` })   
    //     if (req.conversionType == ConversionType.saleorder_to_saleorder) {
    //         updateToBom = await this.bomRepo.update({ saleOrderId: req.toSaleOrderId, itemId: req.itemId }, { AssignedQuantity: () => `assigned_qty+${req.qty}` ,status:StatusEnum.ASSIGNED,requiredQuantity: () => `required_qty-${req.qty}`})       
    //     } 
    //     if (updateFRomSoBom.affected && updateToBom.affected) {
    //         return new CommonResponse(true, 1111, 'Update sucessfully')
    //     } else {
    //         return new CommonResponse(false, 1141, 'Failed to update')
    //     }
    // }

    async updateAssignedAndRequiredQty(req:LocationUpdateRequest): Promise<CommonResponse>{
        try{
            const bomDetails = await this.bomRepo.updateAssignedAndRequiredQty(req);
            if(bomDetails.status){
                return new CommonResponse(true,1001,"",);
            }
            else{
                return new CommonResponse(false,1011,"",);
            }
        }catch (error) {
            return error
        }
    }
}

